import { GraphQLClient } from 'graphql-request';

import { getSdk } from './generated/sdk';
import { requestMiddleware } from './middleware/auth';

export const graphqlClient = new GraphQLClient(`${import.meta.env.VITE_GRAPHQL_URI}/graphql`, {
  requestMiddleware,
});

export const sportySdk = getSdk(graphqlClient);

export type SportySDK = typeof sportySdk;
